import { Injectable } from '@angular/core';
import {
  PaymentData,
  PaymentMethodProps,
  PriceSuggestion,
} from '../models/payment.model';
import { LocalStorageService } from './storage/local-storage.service';
@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private localStorageService: LocalStorageService) {}

  getPayableAmount({
    itemCount,
    itemPrice,
    exchangeRate,
    share,
    discount,
    activationFee,
  }: PaymentMethodProps): {
    payablePrice: number;
    payablePriceWithoutDiscount: number;
  } {
    const discountDecimal = discount / 100;
    const shareDecimal = share / 100;
    let totalPrice: number;
    let priceWithoutDiscount: number;
    priceWithoutDiscount = itemPrice + (activationFee ? activationFee : 0);
    if (discount) {
      const discountFactor = 1 - discountDecimal;

      if (activationFee) {
        totalPrice = itemPrice + activationFee * discountFactor;
      } else {
        totalPrice = itemPrice * discountFactor;
      }
    } else {
      totalPrice = itemPrice + (activationFee ? activationFee : 0);
    }
    return {
      payablePrice: itemCount * exchangeRate * totalPrice * (1 + shareDecimal),
      payablePriceWithoutDiscount:
        itemCount * exchangeRate * priceWithoutDiscount * (1 + shareDecimal),
    };
  }

  getProcessingFee({
    share,
    activationFee,
    itemPrice,
    discount,
    exchangeRate,
    itemCount,
  }: PaymentMethodProps): number {
    const shareValue = +share || 0;
    const activationFeeValue = +activationFee || 0;

    const orderAmount =
      (+itemPrice + activationFeeValue) *
      (1 - +discount / 100) *
      itemCount *
      +exchangeRate;

    return (orderAmount * shareValue) / 100;
  }

  getPriceSuggestions(
    min: number,
    max: number,
    labelPrefix: string
  ): PriceSuggestion[] {
    const step = Math.floor((max - min) / 4 / min) * min || min;
    const values = new Set<number>();

    for (let i = min; i <= max; i += step) {
      values.add(i);
    }
    values.add(max);

    const uniqueValues = Array.from(values)
      .sort((a, b) => a - b)
      .slice(0, 5);

    return uniqueValues.map((value) => ({
      value,
      label: `${labelPrefix}${value}`,
      isActive: false,
    }));
  }

  get paymentData(): PaymentData {
    return this.localStorageService.getItem('checkout');
  }

  setPaymentData(data: PaymentData) {
    return this.localStorageService.setItem('checkout', data);
  }
}
